import { useCallback } from "react";
import { useMedia } from "@medbillai/ui";
import { issuesUrl } from "@medbillai/utils";
import type { CaseAnalyticsSource } from "../../lib/analytics";
import { analyticsService } from "../../lib/analytics";
import { useCasesPanel } from "./CasesPanelProvider";
export type ViewAllCasesAction = {
  /** Set when "view all" navigates; absent when it opens the panel in place. */
  href?: string;
  onPress: () => void;
};

// Wide viewports open the panel in place; narrow ones go to the cases page.
export function useViewAllCasesAction(source: CaseAnalyticsSource): ViewAllCasesAction {
  const media = useMedia();
  const {
    togglePanel
  } = useCasesPanel();
  const opensPanel = media.gtSm;
  const onPress = useCallback(() => {
    analyticsService.trackEvent("ViewAllCasesTapped", {
      source
    });
    if (opensPanel) {
      togglePanel("home_your_cases", true);
    }
  }, [source, opensPanel, togglePanel]);
  return opensPanel ? {
    onPress
  } : {
    href: issuesUrl(),
    onPress
  };
}